import microuniversoApi from "app/api/microuniversoApi"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact"
import { useAppSelector } from "app/redux/hooks"
import React from "react"
import { TelaFormaDePagamentoContainer } from "../TelaFormaDePagamentoContainer"
import { EditarParcelaContrato, EditarParcelaContratoFormulario } from "./EditarParcelaContrato"

export type EditarParcelaContratoContainerProps = {
    somenteLeitura: boolean,
    parcela: EditarParcelaContratoFormulario
}

export const EditarParcelaContratoContainer = (props:EditarParcelaContratoContainerProps) => {
    const orcamento = useAppSelector(state => state.orcamento)


    const aplicar = async (parcela:EditarParcelaContratoFormulario) => {
        
        await microuniversoApi.Orcamento.atualizarParcelaContrato(orcamento.IdentificadorOrcamento,parcela)
        renderizarComponentReact(
            <TelaFormaDePagamentoContainer
                somenteLeitura={props.somenteLeitura}
                abaSelecionada="Plano de Pagamento"
                mostrarDadosDeContratoPorPadrao={true}/>,
            "conteudo-pagina",
            true
        )
    }

    return <>

        <Breadcrumb2Container
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={true}
            id="breadcrumb-editar-parcela-contrato"
            passos={["Formas de Pagamento", "Editar Parcela de Contrato"]}
            onBotaoVoltarClicado={() => {
                renderizarComponentReact(
                    <TelaFormaDePagamentoContainer
                        somenteLeitura={props.somenteLeitura}
                        abaSelecionada="Plano de Pagamento"/>,
                    "conteudo-pagina",
                    true
                )
            }}
            onPassoSelecionado={passo => {
                if (passo == "Formas de Pagamento") {
                    renderizarComponentReact(
                        <TelaFormaDePagamentoContainer
                            somenteLeitura={props.somenteLeitura}
                            abaSelecionada="Plano de Pagamento"/>,
                        "conteudo-pagina",
                        true
                    )
                }
            }}/>
        <EditarParcelaContrato 
            editarParcelaContratoFormulario={props.parcela}
            onAplicar={aplicar} 
            somenteLeitura={props.somenteLeitura}/>
    </>
}